import {Component, OnInit} from '@angular/core';

import {FilterItem} from './filter-item';
import {Item} from './item';
import {ParentItem} from './parent-item';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'ARSelector';
  // http://stackoverflow.com/a/13631733
  items: { [key: string]: Item };
  itemKeys: string[];
  itemKeysCopy: string[];
  filters: { [key: string]: ParentItem };
  filterApplied: number;
  partlySupportedFeatures: boolean;

  visibleMobileNav: boolean;

  ngOnInit() {
    this.filterApplied = 0;
    this.visibleMobileNav = false;
    this.partlySupportedFeatures = false;

    // 'amcs', 'arcl', 'arvo', 'aric', 'arss', 'askv', 'aure', 'bach', 'bast', 'clqu', 'cliq', 'dipo', 'ealm', 'eatm', 'febr', 'form', 'frmp', 'frqd', 'gosb', 'grap', 'invo', 'ipal', 'kaho', 'lars', 'lexs', 'mars', 'ment', 'moqu', 'near', 'onte', 'ping', 'plic', 'poda', 'poev', 'poto', 'quli', 'send', 'shak', 'slid', 'slli', 'smil', 'smsp', 'socr', 'stur', 'swip', 'tedm', 'than', 'twbk', 'unid', 'voxv'

    this.items = {};
    this.items['amcs'] = new Item('Auditorium Mobile Classroom Service', 'AMCS', 'https://amcs.website/', 'assets/logos/amcs.png', '#0D2B50');
    this.items['anga'] = new Item('AnswerGarden', 'AnswerGarden', 'https://answergarden.ch/', 'assets/logos/answergarden.png', '#000');
    this.items['aric'] = new Item('ARSenic', 'ARSenic', 'http://uwmsk.org/arsenic/', 'assets/logos/arsenic.png', '#375815');
    this.items['arap'] = new Item('ARSnova.app', 'ARSnova.eu', 'https://arsnova.eu/', 'assets/logos/arsnovaapp.png', '#DFE5E6');
    this.items['arcl'] = new Item('ARSnova.click', 'ARSnova.click', 'https://arsnova.click/', 'assets/logos/arsnovaclick.png', '#4682B4');
    this.items['arss'] = new Item('ARSServer', 'ARSServer', 'https://github.com/adnanmf/ARSServer', '', '');
    this.items['askv'] = new Item('AskVote', 'AskVote', 'https://www.askvote.io/', 'assets/logos/askvote.png', '#356A97');
    this.items['aure'] = new Item('AuResS', 'AuResS', 'https://www.auress.org/', 'assets/logos/aurees.png', '#222');
    this.items['bach'] = new Item('Backchannel', 'Backchannel', 'http://backchannel.cnc.io/', 'assets/logos/backchannel.png', '#FFF');
    this.items['bast'] = new Item('Backstage', 'Backstage 2.0', 'http://backstage.pms.ifi.lmu.de/', 'assets/logos/backstage.png', '#F6F2EC');
    this.items['clcl'] = new Item('ClassClicker', 'ClassClicker', 'https://classclicker.com/', 'assets/logos/classclicker.svg', '#939393');
    this.items['clqu'] = new Item('ClassQuestion', 'ClassQuestion', 'https://classquestion.com/', 'assets/logos/classquestion.png', '#FFF');
    this.items['cliq'] = new Item('Stud.IP Cliqr', 'Cliqr', 'http://cliqr.de/', '', '#E7E7E7');
    this.items['crsi'] = new Item('Crowdsignal', 'Crowdsignal', 'https://crowdsignal.com/', 'assets/logos/crowdsignal.svg', '#FFF');
    this.items['dipo'] = new Item('DirectPoll', 'DirectPoll', 'http://directpoll.com/', 'assets/logos/directpoll.png', '#FFF');
    this.items['febr'] = new Item('Feedbackr', 'Feedbackr', 'https://www.feedbackr.io/', 'assets/logos/feedbackr.png', '#FFF');
    this.items['form'] = new Item('Formative', 'Formative', 'https://goformative.com/', 'assets/logos/formative.png', '#538EEE');
    this.items['frmp'] = new Item('FreeMobilePolls', 'FreeMobilePolls', 'http://www.freemobilepolls.com/', 'assets/logos/freemobilepolls.gif', '#FFF');
    this.items['frqd'] = new Item('FreeQuizdome', 'FreeQuizdome', 'http://freequizdome.com/', 'assets/logos/freequizdome.png', '#383838');
    this.items['gosb'] = new Item('GoSoapBox', 'GoSoapBox', 'https://www.gosoapbox.com/', 'assets/logos/gosoapbox.png', '#1968b3');
    this.items['grap'] = new Item('Graphicuss', 'Graphicuss', 'https://viscuss.it/', 'assets/logos/graphicuss.png', '#0D2B50');
    this.items['invo'] = new Item('Invote', 'Invote', 'https://invote.de/', 'assets/logos/invote.png', '#C6004D');
    this.items['ipal'] = new Item('IPAL', 'IPAL', 'https://www.compadre.org/iPAL/?', 'assets/logos/ipal.png', '#A95C32');
    this.items['kaho'] = new Item('Kahoot!', 'Kahoot!', 'https://kahoot.com/', 'assets/logos/kahoot.jpg', '#885CD5');
    this.items['lexs'] = new Item('Lexsury', 'Lexsury', 'https://lexsury.com/', 'assets/logos/lexsury.png', '#343a40');
    this.items['mail'] = new Item('mailARS', 'mailARS', 'https://github.com/JoernLoviscach/mailARS/blob/main/README.md', 'assets/logos/mailars.png', '#FFF');
    this.items['mars'] = new Item('Mobile Audience Response System', 'MARS', 'https://danielausparis.github.io/mars/', '', '#492138');
    this.items['ment'] = new Item('Mentimeter', 'Mentimeter', 'https://www.mentimeter.com/', 'assets/logos/mentimeter.png', '#FFF');
    this.items['moqu'] = new Item('ILIAS MobileQuiz', 'MobileQuiz', 'https://github.com/dschoen/mobilequiz', '', '#FFF');
    this.items['near'] = new Item('Nearpod', 'Nearpod', 'https://nearpod.com/', 'assets/logos/nearpod.svg', '#FFF');
    this.items['onte'] = new Item('OnlineTED', 'OnlineTED', 'https://www.onlineted.de/index.php', 'assets/logos/onlineted.gif', '#F8F8F8');
    this.items['ping'] = new Item('Peer Instruction for very large groups', 'PINGO', 'http://trypingo.com/de/', 'assets/logos/pingo.jpg', '#FFF');
    this.items['plic'] = new Item('Plickers', 'Plickers', 'https://www.plickers.com/', 'assets/logos/plickers.png', '#0F365F');
    this.items['poev'] = new Item('Polleverywhere', 'Polleverywhere', 'https://www.polleverywhere.com/', 'assets/logos/polleverywhere.svg', '#FFF');
    this.items['poto'] = new Item('Polltogo', 'Polltogo', 'https://polltogo.com/', 'assets/logos/polltogo.png', '#010346');
    this.items['quli'] = new Item('Quizlet Live', 'Quizlet', 'https://quizlet.com/live', 'assets/logos/quizlet.png', '#4257b2');
    this.items['send'] = new Item('Sendsteps Vote', 'Sendsteps', 'https://www.sendsteps.com/en/products/vote/', 'assets/logos/sendsteps.png', '#FFF');
    this.items['shak'] = new Item('Shakespeak', 'Shakespeak', 'https://www.shakespeak.com/', 'assets/logos/shakespeak.jpg', '#000');
    this.items['slid'] = new Item('Sli.do', 'Sli.do', 'https://www.sli.do/', 'assets/logos/slido.svg', '#32434D');
    this.items['slli'] = new Item('SlideLizard', 'SlideLizard', 'https://www.slidelizard.at/index.html', 'assets/logos/slidelizard.webp', '#683AB6');
    this.items['smil'] = new Item('SMILE - Uni Freiburg', 'SMILE', 'https://www.smile.informatik.uni-freiburg.de/', 'assets/logos/smile.png', '#055E82');
    this.items['smsp'] = new Item('SMSPOLL', 'SMSPOLL', 'http://www.smspoll.net/', 'assets/logos/smspoll.jpg', '#414550');
    this.items['socr'] = new Item('Socrative', 'Socrative', 'https://www.socrative.com/', 'assets/logos/socrative.svg', '#FFF');
    this.items['star'] = new Item('stARS', 'stARS', 'https://www.stars-project.com/', 'assets/logos/stars.svg', '#e9ecef');
    this.items['stur'] = new Item('Sturesy', 'Sturesy', 'https://github.com/sturesy/', 'assets/logos/sturesy.png', '#FFF');
    this.items['swip'] = new Item('Swipe', 'Swipe', 'https://www.swipe.to/', 'assets/logos/swipe.png', '#F6900B');
    this.items['tedm'] = new Item('TEDME', 'TEDME', 'https://tedme.com/home/voting', 'assets/logos/tedme.png', '#2B303A');
    this.items['than'] = new Item('TheAnswerPad', 'TheAnswerPad', 'http://www.theanswerpad.com/', 'assets/logos/theanswerpad.png', '#FFF');
    this.items['twbk'] = new Item('Tweedback', 'Tweedback', 'https://tweedback.de/', 'assets/logos/tweedback.svg', '#FFF');
    this.items['unid'] = new Item('UniDoodle', 'UniDoodle', 'http://www.unidoodle.com/', 'assets/logos/unidoodle.png', '#FFF');
    this.items['voxv'] = new Item('Voxvote', 'Voxvote', 'http://www.voxvote.com/free-audience-response-system/de/voxvote-mobile-voting-app', 'assets/logos/voxvote.png', '#FFF');
    this.items['wocl'] = new Item('Wooclap', 'Wooclap', 'https://www.wooclap.com/de/', 'assets/logos/wooclap.png', '#1b293a');

    // build help structure
    this.itemKeys = [];

    for (const item in this.items) {
      this.itemKeys.push(item);
    }

    this.itemKeys.sort();

    console.log(this.itemKeys);

    this.itemKeysCopy = JSON.parse(JSON.stringify(this.itemKeys));

    /**
     * FILTERS
     */
    this.filters = {};

    // 'amcs', 'arcl', 'arvo', 'aric', 'arss', 'askv', 'aure', 'bach', 'bast', 'clqu', 'cliq', 'dipo', 'ealm', 'eatm', 'febr', 'form', 'frmp', 'frqd', 'gosb', 'grap', 'invo', 'ipal', 'kaho', 'lars', 'lexs', 'mail', 'mars', 'ment', 'moqu', 'near', 'onte', 'ping', 'plic', 'poda', 'poev', 'poto', 'quli', 'send', 'shak', 'slid', 'slli', 'smil', 'smsp', 'socr', 'star', 'stur', 'swip', 'tedm', 'than', 'twbk', 'unid', 'voxv'

    const costs: { [key: string]: FilterItem } = {};

    const freeFullSupportedSystems = ['amcs', 'anga', 'aric', 'arap', 'arcl', 'arss', 'aure', 'bach', 'bast', 'clqu', 'cliq', 'dipo', 'frmp', 'frqd', 'grap', 'invo', 'ipal', 'lexs', 'mail', 'mars', 'moqu', 'ping', 'plic', 'poto', 'smil', 'star', 'stur', 'twbk', 'unid', 'voxv'];
    const freeSupportedSystems = this.sort(freeFullSupportedSystems.concat([]));
    costs['free'] = new FilterItem('Free', freeFullSupportedSystems, freeSupportedSystems);

    const commercialFullSupportedSystems = ['askv', 'clcl', 'crsi', 'febr', 'form', 'gosb', 'kaho', 'ment', 'near', 'onte', 'poev', 'quli', 'send', 'shak', 'slid', 'slli', 'smsp', 'socr', 'swip', 'tedm', 'than', 'wocl'];
    const commercialSupportedSystems = this.sort(commercialFullSupportedSystems.concat([]));
    costs['commercial'] = new FilterItem('Commercial', commercialFullSupportedSystems, commercialSupportedSystems);

    const commercialFreePlanFullSupportedSystems = ['askv', 'clcl', 'crsi', 'form', 'gosb', 'kaho', 'ment', 'near', 'onte', 'poev', 'quli', 'send', 'shak', 'slid', 'slli', 'smsp', 'socr', 'swip', 'tedm', 'than', 'wocl'];
    const commercialFreePlanSupportedSystems = this.sort(commercialFreePlanFullSupportedSystems.concat(['febr']));
    costs['commercial-free-plan'] = new FilterItem('Commercial Free Plan', commercialFreePlanFullSupportedSystems, commercialFreePlanSupportedSystems);

    const openSourceFullSupportedSystems = ['aric', 'arap', 'arcl', 'aure', 'cliq', 'ipal', 'mail', 'mars', 'moqu', 'ping', 'stur'];
    const openSourceSupportedSystems = this.sort(openSourceFullSupportedSystems.concat(['arss', 'frqd']));
    costs['open-source'] = new FilterItem('Open Source', openSourceFullSupportedSystems, openSourceSupportedSystems);


    const language: { [key: string]: FilterItem } = {};

    const chineseFullSupportedSystems = ['crsi', 'quli'];
    const chineseSupportedSystems = this.sort(chineseFullSupportedSystems.concat([]));
    language['chinese'] = new FilterItem('Chinese', chineseFullSupportedSystems, chineseSupportedSystems);

    const spanishFullSupportedSystems = ['arcl', 'crsi', 'quli', 'stur', 'voxv', 'wocl'];
    const spanishSupportedSystems = this.sort(spanishFullSupportedSystems.concat([]));
    language['spanish'] = new FilterItem('Spanish', spanishFullSupportedSystems, spanishSupportedSystems);

    const englishFullSupportedSystems = ['amcs', 'anga', 'aric', 'arap', 'arcl', 'arss', 'askv', 'aure', 'bach', 'bast', 'clcl', 'clqu', 'crsi', 'dipo', 'febr', 'form', 'frmp', 'frqd', 'gosb', 'grap', 'ipal', 'kaho', 'lexs', 'mail', 'mars', 'ment', 'moqu', 'near', 'onte', 'ping', 'plic', 'poev', 'poto', 'quli', 'send', 'shak', 'slid', 'slli', 'smil', 'smsp', 'socr', 'star', 'stur', 'swip', 'than', 'twbk', 'unid', 'voxv', 'wocl'];
    const englishSupportedSystems = this.sort(englishFullSupportedSystems.concat(['lars']));
    language['english'] = new FilterItem('English', englishFullSupportedSystems, englishSupportedSystems);

    const germanFullSupportedSystems = ['amcs', 'arap', 'arcl', 'cliq', 'crsi', 'febr', 'frqd', 'invo', 'mail', 'moqu', 'onte', 'ping', 'quli', 'slli', 'smil', 'stur', 'tedm', 'twbk', 'voxv', 'wocl'];
    const germanSupportedSystems = this.sort(germanFullSupportedSystems.concat([]));
    language['german'] = new FilterItem('German', germanFullSupportedSystems, germanSupportedSystems);


    const setup: { [key: string]: FilterItem } = {};

    const publicServerFullSupportedSystems = ['amcs', 'anga', 'arap', 'arcl', 'askv', 'aure', 'bach', 'bast', 'clcl', 'clqu', 'crsi', 'dipo', 'febr', 'form', 'frmp', 'frqd', 'gosb', 'grap', 'invo', 'kaho', 'lexs', 'ment', 'near', 'onte', 'ping', 'poev', 'poto', 'quli', 'send', 'shak', 'slid', 'slli', 'smsp', 'socr', 'star', 'swip', 'tedm', 'than', 'twbk', 'unid', 'voxv', 'wocl'];
    const publicServerSupportedSystems = this.sort(publicServerFullSupportedSystems.concat(['aric', 'mars', 'smil']));
    setup['public'] = new FilterItem('Public Server', publicServerFullSupportedSystems, publicServerSupportedSystems);

    const externalServerFullSupportedSystems = ['cliq', 'ipal', 'moqu'];
    const externalServerSupportedSystems = this.sort(externalServerFullSupportedSystems.concat(['near']));
    setup['external'] = new FilterItem('Extension of External Server', externalServerFullSupportedSystems, externalServerSupportedSystems);

    const ownServerFullSupportedSystems = ['aric', 'arap', 'arcl', 'arss', 'mars', 'stur'];
    const ownServerSupportedSystems = this.sort(ownServerFullSupportedSystems.concat(['frqd', 'mail']));
    setup['own'] = new FilterItem('Own Server', ownServerFullSupportedSystems, ownServerSupportedSystems);


    const import_: { [key: string]: FilterItem } = {};

    const importGiftFullSupportedSystems = ['ping', 'wocl'];
    const importGiftSupportedSystems = this.sort(importGiftFullSupportedSystems.concat([]));
    import_['gift'] = new FilterItem('GIFT', importGiftFullSupportedSystems, importGiftSupportedSystems);

    const importQtiFullSupportedSystems = ['amcs', 'ping', 'stur'];
    const importQtiSupportedSystems = this.sort(importQtiFullSupportedSystems.concat([]));
    import_['qti'] = new FilterItem('IMS QTI', importQtiFullSupportedSystems, importQtiSupportedSystems);

    const importMoodleFullSupportedSystems = ['ping', 'wocl'];
    const importMoodleSupportedSystems = this.sort(importMoodleFullSupportedSystems.concat([]));
    import_['moodle'] = new FilterItem('Moodle XML', importMoodleFullSupportedSystems, importMoodleSupportedSystems);

    const importOtherFullSupportedSystems = ['arap', 'arcl', 'form', 'frqd', 'ipal', 'mars', 'near', 'ping', 'poev', 'quli', 'stur', 'swip', 'wocl'];
    const importOtherSupportedSystems = this.sort(importOtherFullSupportedSystems.concat(['socr', 'than']));
    import_['other'] = new FilterItem('Other', importOtherFullSupportedSystems, importOtherSupportedSystems);


    const export_: { [key: string]: FilterItem } = {};

    const exportGiftFullSupportedSystems = [];
    const exportGiftSupportedSystems = this.sort(exportGiftFullSupportedSystems.concat([]));
    export_['gift'] = new FilterItem('GIFT', exportGiftFullSupportedSystems, exportGiftSupportedSystems);

    const exportQtiFullSupportedSystems = ['ping'];
    const exportQtiSupportedSystems = this.sort(exportQtiFullSupportedSystems.concat([]));
    export_['qti'] = new FilterItem('IMS QTI', exportQtiFullSupportedSystems, exportQtiSupportedSystems);

    const exportMoodleFullSupportedSystems = ['ping'];
    const exportMoodleSupportedSystems = this.sort(exportMoodleFullSupportedSystems.concat([]));
    export_['moodle'] = new FilterItem('Moodle XML', exportMoodleFullSupportedSystems, exportMoodleSupportedSystems);

    const exportOtherFullSupportedSystems = ['amcs', 'anga', 'arap', 'arcl', 'aure', 'clcl', 'clqu', 'febr', 'frqd', 'gosb', 'invo', 'ipal', 'kaho', 'mars', 'ment', 'moqu', 'near', 'ping', 'poev', 'quli', 'stur', 'swip', 'than'];
    const exportOtherSupportedSystems = this.sort(exportOtherFullSupportedSystems.concat(['crsi', 'form', 'socr', 'star']));
    export_['other'] = new FilterItem('Other', exportOtherFullSupportedSystems, exportOtherSupportedSystems);


    const proprietaryItems: { [key: string]: ParentItem } = {};
    proprietaryItems['costs'] = new ParentItem('Costs', costs);
    proprietaryItems['language'] = new ParentItem('Language', language);
    proprietaryItems['setup'] = new ParentItem('Server Setup', setup);
    proprietaryItems['import'] = new ParentItem('Import', import_);
    proprietaryItems['export'] = new ParentItem('Export', export_);


    const creation: { [key: string]: FilterItem } = {};

    const creationWebFullSupportedSystems = ['amcs', 'anga', 'aric', 'arap', 'arcl', 'arss', 'askv', 'aure', 'bach', 'bast', 'clcl', 'clqu', 'cliq', 'crsi', 'dipo', 'febr', 'form', 'frmp', 'gosb', 'grap', 'invo', 'ipal', 'kaho', 'lexs', 'mars', 'ment', 'moqu', 'near', 'onte', 'ping', 'poev', 'poto', 'quli', 'slid', 'smil', 'smsp', 'socr', 'star', 'swip', 'tedm', 'than', 'twbk', 'voxv', 'wocl'];
    const creationWebSupportedSystems = this.sort(creationWebFullSupportedSystems.concat([]));
    creation['web'] = new FilterItem('Web Application', creationWebFullSupportedSystems, creationWebSupportedSystems);

    const creationMobileFullSupportedSystems = ['kaho', 'near', 'plic', 'poev', 'poto', 'quli', 'slid', 'socr', 'unid'];
    const creationMobileSupportedSystems = this.sort(creationMobileFullSupportedSystems.concat(['anga']));
    creation['mobile'] = new FilterItem('Mobile Application', creationMobileFullSupportedSystems, creationMobileSupportedSystems);

    const creationPresentationFullSupportedSystems = ['ment', 'poev', 'send', 'shak', 'slli'];
    const creationPresentationSupportedSystems = this.sort(creationPresentationFullSupportedSystems.concat(['amcs', 'arap', 'slid']));
    creation['presentation'] = new FilterItem('Presentation Application', creationPresentationFullSupportedSystems, creationPresentationSupportedSystems);

    const creationOtherFullSupportedSystems = ['frqd', 'mail', 'slid', 'stur'];
    const creationOtherSupportedSystems = this.sort(creationOtherFullSupportedSystems.concat([]));
    creation['other'] = new FilterItem('Other', creationOtherFullSupportedSystems, creationOtherSupportedSystems);


    const execution: { [key: string]: FilterItem } = {};

    const executionWebFullSupportedSystems = ['amcs', 'anga', 'aric', 'arap', 'arcl', 'arss', 'askv', 'aure', 'bach', 'bast', 'clcl', 'clqu', 'cliq', 'crsi', 'dipo', 'febr', 'form', 'frmp', 'frqd', 'gosb', 'grap', 'invo', 'ipal', 'kaho', 'lexs', 'mars', 'ment', 'moqu', 'near', 'onte', 'ping', 'poev', 'poto', 'quli', 'send', 'shak', 'slid', 'slli', 'smil', 'smsp', 'socr', 'star', 'stur', 'swip', 'tedm', 'than', 'twbk', 'voxv', 'wocl'];
    const executionWebSupportedSystems = this.sort(executionWebFullSupportedSystems.concat([]));
    execution['web'] = new FilterItem('Web Application', executionWebFullSupportedSystems, executionWebSupportedSystems);

    const executionMobileFullSupportedSystems = ['amcs', 'kaho', 'ment', 'near', 'poev', 'quli', 'slid', 'slli', 'socr', 'unid'];
    const executionMobileSupportedSystems = this.sort(executionMobileFullSupportedSystems.concat(['anga']));
    execution['mobile'] = new FilterItem('Mobile Application', executionMobileFullSupportedSystems, executionMobileSupportedSystems);

    const executionPresentationFullSupportedSystems = ['ment'];
    const executionPresentationSupportedSystems = this.sort(executionPresentationFullSupportedSystems.concat([]));
    execution['presentation'] = new FilterItem('Presentation Application', executionPresentationFullSupportedSystems, executionPresentationSupportedSystems);

    const executionOtherFullSupportedSystems = ['invo', 'ipal', 'mail', 'plic', 'send', 'shak', 'smsp'];
    const executionOtherSupportedSystems = this.sort(executionOtherFullSupportedSystems.concat([]));
    execution['other'] = new FilterItem('Other', executionOtherFullSupportedSystems, executionOtherSupportedSystems);


    const presentation: { [key: string]: FilterItem } = {};

    const presentationWebFullSupportedSystems = ['amcs', 'anga', 'aric', 'arap', 'arcl', 'arss', 'askv', 'aure', 'bach', 'bast', 'clcl', 'clqu', 'cliq', 'crsi', 'dipo', 'febr', 'form', 'frmp', 'gosb', 'grap', 'invo', 'ipal', 'kaho', 'lexs', 'mars', 'ment', 'moqu', 'near', 'onte', 'ping', 'poev', 'poto', 'quli', 'slid', 'smil', 'smsp', 'socr', 'star', 'swip', 'tedm', 'than', 'twbk', 'voxv', 'wocl'];
    const presentationWebSupportedSystems = this.sort(presentationWebFullSupportedSystems.concat([]));
    presentation['web'] = new FilterItem('Web Application', presentationWebFullSupportedSystems, presentationWebSupportedSystems);

    const presentationMobileFullSupportedSystems = ['kaho', 'near', 'plic', 'poev', 'poto', 'quli', 'slid', 'socr', 'unid'];
    const presentationMobileSupportedSystems = this.sort(presentationMobileFullSupportedSystems.concat(['anga']));
    presentation['mobile'] = new FilterItem('Mobile Application', presentationMobileFullSupportedSystems, presentationMobileSupportedSystems);

    const presentationPresentationFullSupportedSystems = ['ment', 'poev', 'send', 'shak', 'slli', 'smsp'];
    const presentationPresentationSupportedSystems = this.sort(presentationPresentationFullSupportedSystems.concat(['amcs', 'arap', 'dipo', 'gosb', 'slid']));
    presentation['presentation'] = new FilterItem('Presentation Application', presentationPresentationFullSupportedSystems, presentationPresentationSupportedSystems);

    const presentationOtherFullSupportedSystems = ['frqd', 'mail', 'ping', 'slid', 'stur'];
    const presentationOtherSupportedSystems = this.sort(presentationOtherFullSupportedSystems.concat(['febr', 'ment']));
    presentation['other'] = new FilterItem('Other', presentationOtherFullSupportedSystems, presentationOtherSupportedSystems);


    const evaluation: { [key: string]: FilterItem } = {};

    const evaluationStudentFullSupportedSystems = ['amcs', 'arap', 'bast', 'clqu'];
    const evaluationStudentSupportedSystems = this.sort(evaluationStudentFullSupportedSystems.concat(['form', 'near', 'poev', 'quli', 'socr', 'than', 'unid']));
    evaluation['student'] = new FilterItem('Student', evaluationStudentFullSupportedSystems, evaluationStudentSupportedSystems);

    const evaluationLecturerFullSupportedSystems = ['amcs', 'arap', 'bast', 'clqu', 'febr', 'form', 'frqd', 'gosb', 'invo', 'kaho', 'ment', 'near', 'poev', 'slid', 'socr', 'than'];
    const evaluationLecturerSupportedSystems = this.sort(evaluationLecturerFullSupportedSystems.concat(['clcl', 'crsi', 'ipal', 'mars', 'moqu', 'onte', 'ping', 'plic', 'poto', 'quli', 'smil', 'star', 'stur', 'swip', 'tedm', 'unid', 'voxv', 'wocl']));
    evaluation['lecturer'] = new FilterItem('Lecturer', evaluationLecturerFullSupportedSystems, evaluationLecturerSupportedSystems);


    const functionalScope: { [key: string]: FilterItem } = {};

    const qualitativeFrontChannelFullSupportedSystems = ['amcs', 'arap', 'form', 'frqd', 'gosb', 'invo', 'ipal', 'mail', 'ment', 'near', 'ping', 'poev', 'quli', 'shak', 'slid', 'socr', 'star', 'stur', 'than', 'unid', 'wocl'];
    const qualitativeFrontChannelSupportedSystems = this.sort(qualitativeFrontChannelFullSupportedSystems.concat(['aure', 'crsi', 'moqu', 'poto', 'smil', 'swip']));
    functionalScope['qualitative-front-channel'] = new FilterItem('Qualitative Front Channel', qualitativeFrontChannelFullSupportedSystems, qualitativeFrontChannelSupportedSystems);

    const quantitativeFrontChannelFullSupportedSystems = ['amcs', 'arap', 'arcl', 'bast', 'clqu', 'cliq', 'crsi', 'dipo', 'febr', 'form', 'frmp', 'frqd', 'gosb', 'invo', 'ipal', 'kaho', 'mars', 'ment', 'moqu', 'near', 'onte', 'ping', 'plic', 'poev', 'poto', 'quli', 'send', 'shak', 'slid', 'slli', 'smil', 'smsp', 'socr', 'star', 'stur', 'swip', 'tedm', 'than', 'twbk', 'unid', 'voxv', 'wocl'];
    const quantitativeFrontChannelSupportedSystems = this.sort(quantitativeFrontChannelFullSupportedSystems.concat(['aure', 'clcl']));
    functionalScope['quantitative-front-channel'] = new FilterItem('Quantitative Front Channel', quantitativeFrontChannelFullSupportedSystems, quantitativeFrontChannelSupportedSystems);

    const qualitativeBackChannelFullSupportedSystems = ['anga', 'arap', 'askv', 'bast', 'gosb', 'grap', 'lexs', 'mail', 'poev', 'poto', 'send', 'slid', 'slli', 'smil', 'star', 'tedm', 'twbk'];
    const qualitativeBackChannelSupportedSystems = this.sort(qualitativeBackChannelFullSupportedSystems.concat(['aric', 'ment']));
    functionalScope['qualitative-back-channel'] = new FilterItem('Qualitative Back Channel', qualitativeBackChannelFullSupportedSystems, qualitativeBackChannelSupportedSystems);

    const quantitativeBackChannelFullSupportedSystems = ['arap', 'bach', 'crsi', 'ping', 'poev', 'smil', 'star', 'twbk'];
    const quantitativeBackChannelSupportedSystems = this.sort(quantitativeBackChannelFullSupportedSystems.concat(['arss', 'gosb', 'kaho', 'ment', 'poto', 'slid', 'slli']));
    functionalScope['quantitative-back-channel'] = new FilterItem('Quantitative Back Channel', quantitativeBackChannelFullSupportedSystems, quantitativeBackChannelSupportedSystems);


    const scenario: { [key: string]: FilterItem } = {};

    const schoolFullSupportedSystems = ['arcl', 'bach', 'form', 'kaho', 'mail', 'ment', 'near', 'plic', 'quli', 'socr', 'swip', 'than', 'unid'];
    const schoolSupportedSystems = this.sort(schoolFullSupportedSystems.concat(['amcs', 'anga', 'arap', 'aure', 'bast', 'dipo', 'febr', 'frqd', 'gosb', 'grap', 'ipal', 'mars', 'moqu', 'ping', 'poev', 'poto', 'slid', 'slli', 'smil', 'star', 'stur', 'twbk', 'wocl']));
    scenario['school'] = new FilterItem('School', schoolFullSupportedSystems, schoolSupportedSystems);

    const universityFullSupportedSystems = ['amcs', 'bast', 'grap', 'ipal', 'mail', 'ment', 'moqu', 'onte', 'ping', 'poev', 'quli', 'smil', 'socr', 'star', 'swip', 'than'];
    const universitySupportedSystems = this.sort(universityFullSupportedSystems.concat(['anga', 'aric', 'arap', 'arss', 'askv', 'bach', 'clcl', 'clqu', 'cliq', 'crsi', 'dipo', 'febr', 'form', 'frqd', 'gosb', 'invo', 'kaho', 'lexs', 'mars', 'near', 'poto', 'send', 'shak', 'slid', 'slli', 'stur', 'tedm', 'twbk', 'unid', 'voxv', 'wocl']));
    scenario['university'] = new FilterItem('University', universityFullSupportedSystems, universitySupportedSystems);

    const eventFullSupportedSystems = ['anga', 'arap', 'clcl', 'dipo', 'gosb', 'poev', 'slid', 'slli', 'tedm', 'twbk', 'wocl'];
    const eventSupportedSystems = this.sort(eventFullSupportedSystems.concat(['amcs', 'aric', 'arss', 'askv', 'aure', 'bach', 'crsi', 'febr', 'frmp', 'invo', 'kaho', 'lexs', 'ment', 'onte', 'ping', 'plic', 'send', 'shak', 'smsp', 'socr', 'star', 'swip', 'voxv']));
    scenario['event'] = new FilterItem('Event', eventFullSupportedSystems, eventSupportedSystems);


    const didacticItems: { [key: string]: ParentItem } = {};
    didacticItems['creation'] = new ParentItem('Creation', creation);
    didacticItems['execution'] = new ParentItem('Execution', execution);
    didacticItems['presentation'] = new ParentItem('Presentation', presentation);
    didacticItems['evaluation'] = new ParentItem('Evaluation', evaluation);
    didacticItems['functional scope'] = new ParentItem('Functional Scope', functionalScope);
    didacticItems['scenario'] = new ParentItem('Scenario', scenario);


    this.filters['proprietary'] = new ParentItem('Proprietary View', proprietaryItems);
    this.filters['didactic'] = new ParentItem('Didactic View', didacticItems);

    this.recalculateRemainingItems();
  }

  sort(array: string[]) {
    return array.sort(function (a, b) {
      const nameA = a.toLowerCase(), nameB = b.toLowerCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0; // default return value (no sorting)
    });
  }

  switchPartlySupportedFeatures(value: any) {
    this.partlySupportedFeatures = value;

    this.recalculateItems();
    this.recalculateRemainingItems();
  }

  toggleFilter(filterItem: FilterItem) {
    filterItem.selected = !filterItem.selected;

    this.filterApplied = filterItem.selected ? this.filterApplied + 1 : this.filterApplied - 1;

    this.recalculateItems();
    this.recalculateRemainingItems();
  }

  // iterate structure and set new list
  recalculateItems() {
    let list: string[] = JSON.parse(JSON.stringify(this.itemKeysCopy));

    for (const filter in this.filters) {
      // license
      for (const subFilter in this.filters[filter].subItems) {
        // open-source | commercial
        for (const criteria in this.filters[filter].subItems[subFilter].subItems) {
          if (this.filters[filter].subItems[subFilter].subItems[criteria].selected) {
            if (this.partlySupportedFeatures) {
              list = this.intersection(list, this.filters[filter].subItems[subFilter].subItems[criteria].allSupportedSystems);
            } else {
              list = this.intersection(list, this.filters[filter].subItems[subFilter].subItems[criteria].fullSupportedSystems);
            }
          }
        }
      }
    }

    this.itemKeys = list;
  }

  // calculate how many items will remain after clicking this
  recalculateRemainingItems() {
    const list: string[] = JSON.parse(JSON.stringify(this.itemKeys));

    for (const filter in this.filters) {
      // license
      for (const subFilter in this.filters[filter].subItems) {
        // open-source | commercial
        for (const criteria in this.filters[filter].subItems[subFilter].subItems) {
          let intersectedList: string[];
          if (this.partlySupportedFeatures) {
            intersectedList = this.intersection(list, this.filters[filter].subItems[subFilter].subItems[criteria].allSupportedSystems);
          } else {
            intersectedList = this.intersection(list, this.filters[filter].subItems[subFilter].subItems[criteria].fullSupportedSystems);
          }
          this.filters[filter].subItems[subFilter].subItems[criteria].remainingItems = intersectedList.length;
        }
      }
    }
  }

  // reset all applied filters
  resetFilters() {
    // reset selected
    for (const filter in this.filters) {
      // license
      for (const subFilter in this.filters[filter].subItems) {
        // open-source | commercial
        for (const criteria in this.filters[filter].subItems[subFilter].subItems) {
          if (this.filters[filter].subItems[subFilter].subItems[criteria].selected) {
            this.filters[filter].subItems[subFilter].subItems[criteria].selected = false;
          }
        }
      }
    }

    // reset fields
    this.filterApplied = 0;
    this.recalculateItems();
    this.recalculateRemainingItems();
  }

  intersection(x, y) {
    x.sort();
    y.sort();
    let i = 0;
    let j = 0;
    const ret = [];
    while (i < x.length && j < y.length) {
      if (x[i] < y[j]) {
        i++;
      } else if (y[j] < x[i]) {
        j++;
      } else {
        ret.push(x[i]);
        i++, j++;
      }
    }
    return ret;
  }
}
